class Modal {
    constructor({ img, title, subtitle, body }) {
        this.img = img;
        this.title = title;
        this.subtitle = subtitle;
        this.body = body;
        this.modalElement = null;
    }

    createMarkup() {
        const container = document.createElement('section');
        container.classList.add('modal-container');
        container.innerHTML = `
            <article class="modal">
                <main class="modal-inner">
                    <figure class="modal-img">
                        <img src="${this.img}" alt="">
                    </figure>
                    <main class="modal-content">
                        <header class="modal-content-header">
                            <h1>${this.title}</h1>
                            <span class="subtitle">${this.subtitle}</span>
                        </header>
                        <main class="modal-content-body">
                            ${this.body}
                        </main>
                    </main>
                </main>
                <nav class="modal-exit">
                    <button class="modal-close">Close</button>
                </nav>
            </article>
        `;
        return container;
    }

    open() {
        // Build and insert modal
        this.modalElement = this.createMarkup();
        document.body.appendChild(this.modalElement);

        // Add body class
        document.body.classList.add('modal-open');

        // Bind close button
        this.modalElement.querySelector('.modal-close')
            .addEventListener('click', () => this.close());
    }

    close() {
        if (!this.modalElement) return;

        // Remove modal-open class
        document.body.classList.remove('modal-open');

        // Remove modal from DOM
        this.modalElement.remove();
        this.modalElement = null;
    }
}

export { Modal };